import React from 'react';
import Hero from './Hero';
import Skills from './Skills';
import About from './About';
import Projects from './Projects';
import Contact from './Contact';
import ServicesSection from './ServicesSection';
import Reviews from './Reviews';
import AIChat from './AIChat';
import AvatarGuide from './AvatarGuide';
import WorkProcess from './WorkProcess';
import useScrollAnimation from './Scroll';
import '../assets/css/style.css';

const MotionReel = React.lazy(() => import('./MotionReel'));

const IndexPage = () => {
  useScrollAnimation();
  return (
    <>
      <Hero />
      <Skills />
      <ServicesSection />
      <WorkProcess />
      <About />
      {/* Reel de motion graphics hecho con Remotion (carga diferida) */}
      <React.Suspense fallback={null}><MotionReel /></React.Suspense>
      <Projects />
      <Reviews />
      <Contact />
      {/* Widget de IA flotante — disponible en toda la página */}
      <AIChat />
      {/* Avatar 3D guía: saluda y hace un recorrido hablado por las secciones */}
      <AvatarGuide />
    </>
  );
};

export default IndexPage;
